define('TescoMobile_Checkout/js/action/get-subscriptions-info',['TescoMobile_DynamicBundleOptions/js/dynamic-options/model/url-builder', 'mage/storage'], function (urlBuilder, storage) {
  'use strict';

  return function (type) {
    const serviceUrl = urlBuilder.createUrl('/get-subscriptions-info/:type', {
      type: type
    });
    return storage.get(serviceUrl);
  };
});

